// src/data/projectsData.js
const projectsData = [
  {
    id: 'My_portfolio_website',
    title: 'My Portfolio Website',
    summary:
      'A responsive developer portfolio built with React to showcase projects, skills, and professional growth through a refined dark-themed editorial interface.',
    tech: ['React', 'JavaScript', 'CSS', 'GSAP', 'GitHub Pages'],
    image: './images/My_portfolio_image.png',
    github: 'https://github.com/Pradeepkumarsirigirisetty',
    demo: 'https://pradeepkumarsirigirisetty.github.io',
    details: '/projects/My_portfolio_website',
    subtitle:
      'A responsive and refined portfolio website created to present projects, skills, and personal branding in a polished and structured format.',
    about:
      'This portfolio website was built to establish a stronger digital presence and present work with cleaner visual hierarchy and improved responsiveness. It reflects a more professional approach to showcasing personal projects and technical growth — built with React and animated with GSAP for a premium user experience.',
    image1: '/images/portfolio-1.jpg',
    image2: '/images/portfolio-2.jpg',
    showOnHome: false
  },
  {
    id: 'trione-marketing-co',
    title: 'Trione Marketing.co',
    summary:
      'Co-founded and built the company website for a modern marketing agency offering web development, cinematic video production, and AI business agent services for local businesses.',
    tech: ['HTML', 'CSS', 'JavaScript', 'React', 'Responsive UI'],
    image: './images/Trione_home_page.png',
    github: 'https://github.com/Pradeepkumarsirigirisetty',
    demo: 'https://pradeepkumarsirigirisetty.github.io/Trione_Marketing.co/',
    details: '/projects/trione-marketing-co',
    subtitle:
      'A modern agency website created to showcase website development, cinematic video production, and AI business agent services for local businesses.',
    about:
      'As co-founder of Trione Marketing.co, I built and maintained the company website with a clean, responsive interface using modern web technologies. I improved online presence and branding by optimizing UX and layout for better user engagement and client conversion.',
    image1: '/images/Trione_service_page.png',
    image2: '/images/Trione_team_page.png',
    showOnHome: true
  },
  {
    id: 'busina-vinay-kumar-photographer-portfolio',
    title: 'Photographer Portfolio Website',
    summary:
      'A clean and visually focused portfolio website built to showcase photography work — product shoots, brand campaigns, lifestyle portraits, and social media visuals.',
    tech: ['HTML', 'CSS', 'JavaScript', 'Responsive UI'],
    image: './images/Vinay_portfolio_image.png',
    github: 'https://github.com/Pradeepkumarsirigirisetty',
    demo: 'https://durgavinaykumar6666.github.io',
    details: '/projects/busina-vinay-kumar-photographer-portfolio',
    subtitle:
      'A visually focused photographer portfolio website built to present photography work in a clean and professional format with high-performance image rendering across devices.',
    about:
      'Developed a portfolio website to showcase photography work using React and responsive design principles. Focused on a simple, clean gallery interface to ensure high-performance image rendering across devices.',
    image1: '/images/vinay-photo-1.jpg',
    image2: '/images/vinay-photo-2.jpg',
    showOnHome: true
  },
  {
    id: 'ai-automation-n8n',
    title: 'AI Automation Workflows (n8n)',
    summary:
      'Designed and deployed multi-step AI agent workflows in n8n — transforming scripts into podcast audio, orchestrating WhatsApp/Telegram bots, and integrating APIs for complex task automation.',
    tech: ['n8n', 'LLMs', 'AI Agents', 'WhatsApp API', 'Telegram API', 'Python'],
    image: './images/uptrend_image.png',
    github: 'https://github.com/Pradeepkumarsirigirisetty',
    demo: '#',
    details: '/projects/ai-automation-n8n',
    subtitle:
      'Multi-step AI automation workflows built in n8n, integrating LLMs, agentic pipelines, and communication APIs for real-world business automation.',
    about:
      'Designed and deployed multi-step AI workflows in n8n that transform scripts into podcast-style audio using LLM integrations. Orchestrated agentic workflows for WhatsApp and Telegram, including chat-based auto-reply systems and intelligent shopping agents. Integrated business tools and APIs to automate complex data processing and communication tasks.',
    image1: '/images/uptrend-1.jpg',
    image2: '/images/uptrend-2.jpg',
    showOnHome: true
  },
  {
    id: 'uptrend',
    title: 'Uptrend — Finance Dashboard UI',
    summary:
      'A finance-oriented web platform making investing and market exploration more approachable through onboarding flows, trading-focused layouts, and educational interface sections.',
    tech: ['HTML', 'CSS', 'JavaScript', 'Finance UI', 'Auth Flow'],
    image: './images/uptrend_image.png',
    github: 'https://github.com/Pradeepkumarsirigirisetty',
    demo: 'https://uptrend.niat.tech',
    details: '/projects/uptrend',
    subtitle:
      'A finance-oriented web project crafted to make investing and market exploration more engaging through structured layouts and contemporary interface sections.',
    about:
      'Uptrend was developed as a visually driven and functionally clear web experience that highlights frontend styling, layout composition, and user-focused presentation. The project reflects a modern interface with a stronger sense of purpose and direction for finance-related products.',
    image1: '/images/uptrend-1.jpg',
    image2: '/images/uptrend-2.jpg',
    showOnHome: false
  },
];

export default projectsData;